import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

const MembersCarousel = () => {
	const sliders = document.querySelectorAll('.ahha-members-carousel__swiper');

	if (sliders) {
		sliders.forEach((slider) => {
			const slides = slider.querySelectorAll('.swiper-slide');

			if (slides.length > 0) {
				let swiper = null;

				const params = {
					modules: [Pagination, Autoplay, Navigation],
					autoplay: {
						delay: 3000,
						disableOnInteraction: false,
					},
					pagination: {
						el: slider.querySelector('.swiper-pagination'),
						clickable: true,
					},
					navigation: {
						nextEl: slider.nextElementSibling,
						prevEl: slider.previousElementSibling,
					},
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 20,
					autoHeight: true,
					loop: false,
				};

				const mobileParams = {
					modules: [Pagination, Autoplay, Navigation],
					autoplay: {
						delay: 3000,
						disableOnInteraction: false,
					},
					pagination: {
						el: slider.querySelector('.swiper-pagination'),
						clickable: true,
					},
					navigation: {
						nextEl: slider.nextElementSibling,
						prevEl: slider.previousElementSibling,
					},
					centeredSlides: true,
					initialSlide: 1,
					slidesPerView: 1.5,
					spaceBetween: 20,
					autoHeight: true,
					loop: false,
				};

				if (window.innerWidth >= 1200) {
					swiper = new Swiper(slider, params);
				} else {
					swiper = new Swiper(slider, mobileParams);
				}

				window.addEventListener('resize', () => {
					if (window.innerWidth >= 1200) {
						if (swiper.initialized) {
							swiper.destroy();
						}

						swiper = new Swiper(slider, params);
					} else {
						if (swiper.initialized) {
							swiper.destroy();
						}

						swiper = new Swiper(slider, mobileParams);
					}
				});
			}
		});
	}
};

domReady(() => {
	MembersCarousel();
});
